// eslint-disable-next-line no-restricted-imports
import type { Classroom } from "@monsterverse/island-types";

import MockStudent from "../api/mocks/getStudentUserStudent.json";
import { mocksResponse } from "../utils/env";
import { UserManager } from "./UserManager";

export class StudentManager {
  private static _instance: StudentManager = new StudentManager();
  static get instance(): StudentManager {
    return this._instance;
  }

  private _classrooms: Classroom[] | undefined;

  async syncStudents(dataProvider: () => Promise<Classroom[]>) {
    if (!UserManager.instance.userId) {
      throw Error("Error syncing students for undefined user.");
    }
    if (mocksResponse()) {
      // return mocked reponse to avoid CORS errors in dev
      this._classrooms = MockStudent._items[0].classes.map((c) => {
        return {
          _id: c._id,
          name: c.name,
          archived: c.archived,
          teacher: c.teacher && {
            _id: c.teacher._id,
            title: c.teacher.title,
            firstName: c.teacher.firstName,
            lastName: c.teacher.lastName,
            avatarUrl: c.teacher.avatarURL,
          },
        };
      });
      return;
    }
    const classes = await dataProvider();
    this._classrooms = classes;
  }

  get classes(): Classroom[] {
    return this._classrooms ?? [];
  }
  set classes(classes: Classroom[]) {
    this._classrooms = classes;
  }

  get sortedClasses(): Classroom[] {
    return this.classes.sort((a, b) => b._id.localeCompare(a._id));
  }
}
